import React from 'react';
import PropTypes from 'prop-types';

/**
 * SelectYugiType
 */
class SelectYugiType extends React.Component {

  // このボックスの表示データを取得
  componentDidMount() {
    this.props.comactions.onMountedYugiType();
  }

  render() {
    const actions = this.props.actions;
    let itemList = this.props.data.itemList.yugitypeList;

    // 画面表示"すべて"を追加する。
    let displayItemList = [{ vcs_yugi_type_code: '', type_mei: 'すべて' }];
    if (itemList.length > 0) {
      let j = 1;
      for (let i = 0; i < itemList.length; i++) {
        displayItemList[j++] = itemList[i];
      }
    }

    const nodes = displayItemList.map((item) => {
      return (
        <option value={item.vcs_yugi_type_code} key={item.vcs_yugi_type_code}>
          {item.type_mei}
        </option>
      );
    });
    const yugitype = this.props.data.yugitype;

    return (
      <div>
        <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable controlForm__text--state_enable"><p>遊技タイプ</p></div>
        <label className="select">
          <select name="pw_extraction_02" id="selectYugiType" value={yugitype} onChange={e => actions.changeYugiType(e.target.value)}>
            {nodes}
          </select>
        </label>
      </div>
    );
  }
}

SelectYugiType.propTypes = {
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectYugiType;
